<template>
  <div class="booth-list">
    <div class="list-table__title">Booth List</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="booths"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'Booth ID',
        },
        {
          key: 'university.name',
          label: 'University',
        },
        {
          key: 'campus.name',
          label: 'Campus',
        },
        {
          key: 'building',
          label: 'Building',
        },
        {
          key: 'room',
          label: 'Room No',
        },
        {
          key: 'number',
          label: 'Number',
        },
        {
          key: 'size',
          label: 'Size',
          formatter: (size) => this.formatSize(size),
        },
        {
          key: 'status',
          label: 'Status',
          formatter: (status) => this.formatStatus(status),
        },
      ],
    };
  },

  props: {
    booths: Array,
  },

  methods: {
    formatSize(size) {
      if (size === 'l') {
        return 'Large';
      }
      return 'Small';
    },

    formatStatus(status) {
      if (status) {
        return 'Active';
      }
      return 'Close';
    },
  },
};
</script>

<style>
.booth-list .list-table .list-table__head {
  font-size: .8rem;
}

.booth-list .list-table .list-table__body td {
  font-size: .8rem;
}
</style>
